import "./WorkGallery.module.css";
import Header from "@/reusable_sections/Header";
import RegionalTransformations from "./sections/RegionalTransformations";
import TropicalDurabilityFactor from "./sections/TropicalDurabilityFactor";
import Footer from "@/reusable_sections/Footer";
export default function WorkGalleryPage() {
  return <div>
      <Header />
      <RegionalTransformations />
      <TropicalDurabilityFactor />
      <Footer />
    </div>;
}